// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uBrR1","right":"styles_right__2JKqX"};